import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from './pages/Home';
import About from "./pages/Aboutus";
import Services from "./pages/Services";
import Contact from "./pages/Contacts";
import Products from "./pages/Products";
import Ourtechnologies from "./pages/Ourtechnologies";
import Crms from "./pages/products/Crms";
// 👉 Uncomment if you have Training page
// import Training from "./pages/Training";


// 🔥 Title Manager (SEO Titles for each page)
function TitleManager() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    const titles = {
      "/": "Home | Doddamani TechDev",
      "/about": "About Us | Doddamani TechDev",
      "/services": "Services | Doddamani TechDev",
      "/contact": "Contact | Doddamani TechDev",
      "/products": "Products | Doddamani TechDev",
      "/ourtechnologies": "Technologies | Doddamani TechDev",
      "/crms": "CRM Software | Doddamani TechDev",
      // "/training": "Training | Doddamani TechDev"
    };

    document.title = titles[path] || "Doddamani TechDev | Web & Software Solutions";

  }, [location]);

  return null;
}


// 🚀 Main App Component
function App() {
  return (
    <Router>

      {/* 🔥 Dynamic Title Manager */}
      <TitleManager />

      {/* Navbar */}
      <Navbar />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ourtechnologies" element={<Ourtechnologies />} />
        <Route path="/products" element={<Products />} />
        <Route path="/crms" element={<Crms />} />

        {/* 👉 Uncomment if Training page exists */}
        {/* <Route path="/training" element={<Training />} /> */}

      </Routes>

      {/* Footer */}
      <Footer />

    </Router>
  );
}

export default App;